import { history } from "../_helpers";
export const keyManageServices = {
  getAllKeys,
  getKeyManageTopCardInfo,
  createKey,
  getAllOpenAPIs,
  getOpenAPIForUser,
  getAPIKeyDetails,
  editAPIKey,
  assignOpenAPIForUser,
  applyApiKeyFilter,
  getApiKeyFilters,
  deleteApiKey,
  activeApiKey,
};

function getAllKeys(offset = 0, limit = 10) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/apikeys/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getKeyManageTopCardInfo() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/apikey/cards`,
    requestOptions
  ).then(handleResponse);
}

function createKey(formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/apikey`,
    requestOptions
  ).then(handleResponse);
}

function getAllOpenAPIs() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/openapi`,
    requestOptions
  ).then(handleResponse);
}

function getOpenAPIForUser(userId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/openapi/${userId}`,
    requestOptions
  ).then(handleResponse);
}

function getAPIKeyDetails(apiKeyManagementId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/apikey/${apiKeyManagementId}`,
    requestOptions
  ).then(handleResponse);
}
function editAPIKey(formData, apiKeyManagementId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify(formData, apiKeyManagementId),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/apikey/${apiKeyManagementId}`,
    requestOptions
  ).then(handleResponse);
}

function assignOpenAPIForUser(formData, userId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/openapi/assign/${userId}`,
    requestOptions
  ).then(handleResponse);
}
//applyApiKeyFilter
function applyApiKeyFilter(
  accessUser,
  createduser,
  isActive,
  isDeleted,
  startDate,
  endDate,
  search,
  offset,
  limit
) {
  let user = JSON.parse(localStorage.getItem("user"));
  const sortBy = "DESC";
  const columnName = null;
  const requestOptions = {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify({
      accessUser,
      createduser,
      isActive,
      isDeleted,
      startDate,
      endDate,
      search,
    }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/apikey/filter/${limit}/${offset}/${sortBy}/${columnName}`,
    requestOptions
  ).then(handleResponse);
}
//getApiKeyFilters
function getApiKeyFilters() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/apikey/filter/props`,
    requestOptions
  ).then(handleResponse);
}

//Activate API Key

function activeApiKey(isActive, apiKeyManagementId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify({ isActive }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/apikey/activate/${apiKeyManagementId}`,
    requestOptions
  ).then(handleResponse);
}

//Delete API Key

function deleteApiKey(apiKeyManagementId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": user.accessToken,
      "content-type": "application/json",
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/apikey/${apiKeyManagementId}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      // if (response.status === 401) {
      // }
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        //redirecting to signin page
        history.push("/auth/signin");
        //removing local storage token
        localStorage.removeItem("user");
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
